import { ActiveFarmTypography } from '../../components/CustomStyles/StyledComponents';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setAdminFarmId } from "../../store/appAction";
import Button from '@mui/material/Button';

export default function SelectedFarm() {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    
    const farmId = useSelector(state => state?.adminFarm?.farmDetails?.friendlyFarmId);
    const farmUUID = useSelector(state => state?.adminFarm?.farmId);
    const farmName = useSelector(state => state?.adminFarm?.farmDetails?.farmName);

    const gotoFarm = (farmUUID) => {
        dispatch(setAdminFarmId(farmUUID));
        navigate('/admin/farm/edit')
    }

    const NoFarm = "No farm selected";
    return (
        <ActiveFarmTypography style={{ marginBottom: '5px' }}>
            <span style={{ fontWeight: 'bold' }}>Active Farm :  </span>{farmId && farmName ?
                <Button variant="text" onClick={() => {gotoFarm(farmUUID)}}>
                    <ActiveFarmTypography style={{ textTransform: "none" }}>
                    {farmId?`${farmId} - `:''} {farmName}</ActiveFarmTypography>
                </Button> :
                NoFarm
            }
        </ActiveFarmTypography>
    );
}

